import { IRedirectToResponse, IResponse } from '@booking-portal/types/api';
import { publicHttpClient } from '@booking-portal/utils/fetch-utils';

export function getRedirectTo(): Promise<IResponse<IRedirectToResponse>> {
  return publicHttpClient
    .get('/redirect-to')
    .then((response) => response.data)
    .then((res) => {
      console.info('/redirect-to', res?.data);
      return res;
    });
}
